import { cn } from '@/lib/utils';
import { useState } from 'react';
import { PDKNoUserIcon } from '../pdk-icons';
import { Avatar, AvatarFallback, AvatarImage } from './avatar';

const PaddockAvatar = ({
  src,
  alt,
  fallback,
  className,
  avatarClassName,
}: {
  src: string;
  alt: string;
  fallback: string;
  className?: string;
  avatarClassName?: string;
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <Avatar className={cn('size-5 rounded-full', className)}>
      <AvatarImage
        src={src}
        alt={alt}
        onLoad={() => setIsLoaded(true)}
        onAbort={() => {
          setIsLoaded(true);
        }}
        onError={() => {
          setIsLoaded(true);
        }}
        className={cn('size-5 rounded-full', avatarClassName)}
      />
      {!isLoaded && (
        <AvatarFallback className={cn('size-5 rounded-full', avatarClassName)}>
          <PDKNoUserIcon
            className={cn('size-5 rounded-full', avatarClassName)}
          />
        </AvatarFallback>
      )}
      {isLoaded && (
        <AvatarFallback className={cn('size-5 rounded-full', avatarClassName)}>
          {fallback}
        </AvatarFallback>
      )}
    </Avatar>
  );
};

export default PaddockAvatar;
